import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MenuSharedFacade, SlideViewerFacade } from '@medsurf/flat-facades';
import { MediaControlService } from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-slide-main',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './slide-main.component.html',
    styleUrls: ['./slide-main.component.scss'],
    standalone: false
})
export class SlideMainComponent {
  /**
   * Constructor
   *
   * @param slideViewerFacade
   * @param menuSharedFacade
   * @param mediaControlService
   */
  public constructor(public slideViewerFacade: SlideViewerFacade,
                     public menuSharedFacade: MenuSharedFacade,
                     public mediaControlService: MediaControlService) {
  }
}
